import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'
import { css } from '@linaria/core'

import closeModal from '../../utils/closeModal'
import Modal from '../common/modal'
import Icon from '../icon'

const container = css`
  padding: 0px;
  border-radius: 0px;
  border-width: 0px;
  width: calc(100% - 24px);
`

const Header = styled.div`
  height: 60px;
  padding: 0 16px;
  background-color: var(--secondary);
  h3 {
    font-size: 17px;
    font-family: 'Syncopate-Bold';
    color: var(--txt);
    text-transform: uppercase;
  }
  button {
    display: flex;
    svg {
      fill: var(--txt);
    }
  }
`

const Text = styled.p`
  font-family: 'Avenir-Medium';
  color: #959595;
  font-size: 15px;
`

const Content = styled.div`
  padding: 32px;
`

const List = styled.ul`
  margin: 16px 0 24px;
  padding: 0 24px;
  li {
    font-family: 'Avenir-Medium';
    color: #959595;
    font-size: 15px;
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const RedeemBonusDetailsModal = () => {
  const modal = useModal()
  const { t } = useTranslation('redeemBonus')

  return (
    <Modal id="redeem-bonus-details-modal" containerStyle={container}>
      <Header className="flx-btw-ctr">
        <h3>{t('bonus-code')}</h3>
        <button onClick={() => closeModal(modal)}>
          <Icon id="close" width="15" height="15" />
        </button>
      </Header>
      <Content>
        <Text>{t('many-places')}</Text>
        <List>
          <li>{t('announcements')}</li>
          <li>{t('email')}</li>
          <li>{t('campaigns')}</li>
          <li>{t('social-media')}</li>
        </List>
        <Text>{t('have-fun')}</Text>
      </Content>
    </Modal>
  )
}

export default NiceModal.create(RedeemBonusDetailsModal)
